import { Text, Heading, Stack, Box } from 'braid-design-system';
import React from 'react';

import ImageCard from '../ImageCard/ImageCard';

import * as styles from './style.css';

interface ListingCardProps {
  title: string;
  url: string;
  imageUrl: string;
  location: string;
  investment: string;
  htag: string;
}

const ListingCard = (props: ListingCardProps) => (
  <ImageCard {...props}>
    <Box className={styles.container}>
      <Box className={styles.title}>
        <Heading level="4">
          <Box className={styles.displayLink}>{props.title}</Box>
        </Heading>
      </Box>
      <Stack space="small">
        <Text size="small">{props.location}</Text>
        <Text size="small">{props.investment}</Text>
      </Stack>
    </Box>
  </ImageCard>
);
export default ListingCard;
